module.exports = __webpack_public_path__ + "764fe8466b23c26c142f69afc50f2f2a.svg";